export default __webpack_public_path__ + "static/media/location.73ac27f0.svg";